export const receiptsEndpoints = {
  createReceipt: { method: 'post', path: '/' },
  createReceiptUpload: { method: 'post', path: '/uploads' },
  getReceiptsByPurchaseOrderId: { method: 'get', path: '/by-purchase-order/{purchaseOrderId}' },
  getReceivingStatusByPurchaseOrderId: { method: 'get', path: '/by-purchase-order/{purchaseOrderId}/receiving-status' },
  getActiveReceiptUploadsByPurchaseOrderId: { method: 'get', path: '/by-purchase-order/{purchaseOrderId}/uploads' },
  voidReceiptLineItem: { method: 'post', path: '/line-items/{receiptLineItemId}/void' },
} as const
